// extracted by mini-css-extract-plugin
export default {"menuList":"styles_menuList__ZqXXj","item":"styles_item__fBGHF","menuItemBox":"styles_menuItemBox__Sxkov","obliqueLine":"styles_obliqueLine__8MMx2","badge":"styles_badge__D4HGz"};